import React, { useEffect, useRef, useState } from "react";
import { Search, X } from "lucide-react";

interface ProducaoSalaoBuscaProps {
  value: string;
  onChange: (value: string) => void;
}

/** Lupa minimalista que abre campo de busca por mesa/comanda. */
const ProducaoSalaoBusca: React.FC<ProducaoSalaoBuscaProps> = ({
  value,
  onChange,
}) => {
  const [open, setOpen] = useState(Boolean(value));
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Buscar mesa ou comanda"
        title="Buscar mesa ou comanda"
        className="flex shrink-0 items-center justify-center rounded-lg border border-neutral-300 p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-700"
      >
        <Search size={16} strokeWidth={2} />
      </button>
    );
  }

  return (
    <div className="flex min-w-0 max-w-[11rem] items-center gap-1 rounded-lg border border-neutral-300 bg-white px-2 py-1.5 sm:max-w-[14rem]">
      <Search size={14} className="shrink-0 text-neutral-400" strokeWidth={2} />
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Mesa / comanda"
        aria-label="Buscar por mesa ou comanda"
        className="min-w-0 flex-1 bg-transparent text-sm text-neutral-700 outline-none placeholder:text-neutral-400"
      />
      <button
        type="button"
        onClick={() => {
          onChange("");
          setOpen(false);
        }}
        aria-label="Fechar busca"
        className="shrink-0 rounded p-0.5 text-neutral-400 hover:text-neutral-600"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default ProducaoSalaoBusca;
